/* Size chart: abrir/fechar a janela e alternar cm / in */
(function () {
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;
  window.__sizeUnit = 'cm';

  function toInches(txt) {
    return txt.replace(/\d+(?:\.\d+)?/g, function (n) {
      return (parseFloat(n) / 2.54).toFixed(1);
    });
  }

  function applyUnit(dlg, unit) {
    dlg.setAttribute('data-unit', unit);
    var cells = dlg.querySelectorAll('td[data-cm]');
    for (var i = 0; i < cells.length; i++) {
      var cm = cells[i].getAttribute('data-cm');
      cells[i].textContent = unit === 'in' ? toInches(cm) : cm;
    }
    var heads = dlg.querySelectorAll('th[data-label]');
    for (var j = 0; j < heads.length; j++) {
      var label = heads[j].getAttribute('data-label');
      heads[j].textContent = unit === 'in' ? label.replace('(CM)', '(IN)') : label;
    }
    var btns = dlg.querySelectorAll('[data-size-unit]');
    for (var k = 0; k < btns.length; k++) {
      var on = btns[k].getAttribute('data-size-unit') === unit;
      btns[k].classList.toggle('is-active', on);
      btns[k].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-chart-open]');
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      var dlg = document.getElementById(open.getAttribute('data-size-chart-open'));
      if (!dlg) return;
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      applyUnit(dlg, window.__sizeUnit || 'cm');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      return;
    }
    var unitBtn = e.target.closest('[data-size-unit]');
    if (unitBtn) {
      e.preventDefault();
      var unit = unitBtn.getAttribute('data-size-unit');
      window.__sizeUnit = unit;
      applyUnit(unitBtn.closest('dialog'), unit);
      return;
    }
    var close = e.target.closest('[data-size-chart-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.size-chart-dialog')) {
      e.target.close();
    }
  });
})();